export const getCellStyle = ({ value, context, colDef }) => {
  let style = {
    backgroundColor: '#ffffff',
    color: '#666666',
  }
  //if value is not defined, no color coding
  if (value === null || isNaN(value)) {
    return style
  }
  const colId = colDef.pivotValueColumn?.colId ?? colDef.colId //If pivot is active (any column in column label), then colId should be from the pivotValueColumn
  if (context[colId]?.red.enabled) {
    if (context[colId]?.red.criteria === '>=') {
      if (value >= context[colId]?.red.value) {
        style = { backgroundColor: 'red!important', color: 'white!important' }
      }
    }
    if (context[colId]?.red.criteria === '<') {
      if (value < context[colId]?.red.value) {
        style = { backgroundColor: 'red!important', color: 'white!important' }
      }
    }
  }
  if (context[colId]?.green) {
    if (context[colId]?.green.criteria === '>=') {
      if (value >= context[colId]?.green.value) {
        style = { backgroundColor: 'green!important', color: 'white!important' }
      }
    }
    if (context[colId]?.green.criteria === '<') {
      if (value < context[colId]?.green.value) {
        style = { backgroundColor: 'green!important', color: 'white!important' }
      }
    }
  }
  if (
    context[colId]?.green.enabled &&
    context[colId]?.red.enabled &&
    style.color === '#666666'
  ) {
    style = { backgroundColor: 'yellow!important', color: 'black!important' }
  }
  return style
}
